import React from 'react';

const SectionHeading = ({ heading }) => {
    return (
        <div className='sectionHeading'>
            <h4>{heading}</h4>
            <hr />
        </div>
    );
};

export default SectionHeading;
